module.exports = __webpack_public_path__ + "static/DIY as Privilege - Greek-1a3152c4c2c45fe4b45c75b0e6fdd169.pdf";